import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo-head";
import BookCall from "@/pages/BookCall";

export const Route = createFileRoute("/book/")({
  component: BookCall,
  head: () =>
    pageHead({
      title: "Book a Strategy Call | jaik",
      description: "Schedule a free 20-minute strategy call with jaik. Pick a time that works for you and we will map out your contractor website and local SEO plan.",
      path: "/book",
    }),
});
